module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp3_8017.65771176.png";